<form action="" [formGroup]="newslettersForm">
  <h5 class="sub-title mb-3">{{ datas.title }} Newsletters</h5>
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="form-rows">
        <mat-form-field class="material-full-width" appearance="outline">
          <mat-label>Title <span class="text-danger">*</span></mat-label>
          <input
            matInput
            placeholder="Enter Title"
            formControlName="title"
            [ngClass]="{ 'is-invalid': add.title.touched && add.title.errors }"
          />
          <mat-error *ngIf="add.title.touched && add.title.errors">
            <span *ngIf="add.title.errors.required">Title is required</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
      <div class="p-relative">
        <p class="logo-span">Document<span class="text-danger">*</span></p>
        <div class="text-center">
          <div class="circle" *ngIf="image_url">
            <a class="d-image" href="{{ image_url }}" target="_blank"
              ><i class="fas fa-eye"></i> View Document</a
            >
          </div>
          <div>
            <div *ngIf="selectedFileName">
              <p><strong>Selected File:</strong> {{ selectedFileName }}</p>
            </div>
            <label for="files" (click)="onUpload()" class="p-image"
              >Upload Document</label
            >
            <input
              class="file-upload"
              #fileInput
              accept=".pdf"
              (change)="onSelectImage($event)"
              id="files"
              type="file"
            />
          </div>
        </div>
        <p>
          <span class="noti-span"
            >(Supported Format:pdf) <br />(max file size: 10mb)</span
          >
        </p>
        <p *ngIf="logoCheck == true" class="text-danger">
          Documents is required
        </p>
        <p *ngIf="img == 'show'" class="text-danger">Format is invalid</p>
      </div>
    </div>
  </div>
  <div class="text-center mt-5">
    <button
      class="mr-2 new-btn-color"
      mat-raised-button
      color="primary"
      (click)="savenewsEvent()"
    >
      Save
    </button>
    <button
      class="mr-2 new-btn-color2"
      mat-raised-button
      color="warn"
      (click)="cancelEvent()"
    >
      Cancel
    </button>
  </div>
</form>
